module.exports = __webpack_public_path__ + "img/diente55.fa11fe76.png";